import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import "@/assets/style/common.scss";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { toast } from "@/utils/toast";
import { Dialog } from "vant";
import { localCache } from "@/utils/Cache";
import { userinfo } from "@/common/api/http.api.login";
import { getCookie } from "@/utils/getCookie";

createApp(App)
  .use(store)
  .use(router)
  .use(Vant)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .mount("#app");
